module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_3.74af9bc1.pdf";